module.exports = __webpack_public_path__ + "static/media/Productos.345ccd5a.pdf";